// extracted by mini-css-extract-plugin
module.exports = {"containerText":"payment-method_containerText__-Z-L_","title":"payment-method_title__2fBQQ"};